import {
    GET_FLEET_ASSET_COMMENTS_HISTORY,
    GET_FLEET_ASSET_COMMENTS_SAVE,
    SET_FLEET_ASSET_COMMENTS_HISTORY,
    SET_FLEET_ASSET_COMMENTS_SAVE
} from "./FleetAssetCommentsSaveType"

const getSaveFleetComments = (fleetCommentsSave: any) => ({
    type: GET_FLEET_ASSET_COMMENTS_SAVE,
    fleetCommentsSave
})

const setSaveFleetComments = (fleetAssetComments: any) => ({
    type: SET_FLEET_ASSET_COMMENTS_SAVE,
    fleetAssetComments: fleetAssetComments
})

const getFleetCommentsHistory = (orderId: any) => ({
    type: GET_FLEET_ASSET_COMMENTS_HISTORY,
    orderId
})

const setFleetCommentsHistory = (history: any) => ({
    type: SET_FLEET_ASSET_COMMENTS_HISTORY,
    history
})

export {
    getSaveFleetComments,
    setSaveFleetComments,
    getFleetCommentsHistory,
    setFleetCommentsHistory
}